// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import contractAmendmentEntity from './entities/contract-amendment.json';
import contractAmendmentMenu from '../pages/contract-amendment/menu.json';
import contractAmendmentFullForm from '../pages/contract-amendment/forms/full.json';
import contractAmendmentContextForm from '../pages/contract-amendment/forms/context.json';
import contractAmendmentMiniForm from '../pages/contract-amendment/forms/mini.json';
import contractAmendmentLookupForm from '../pages/contract-amendment/forms/lookup.json';
import contractAmendmentTableView from '../pages/contract-amendment/views/table.json';
import contractAmendmentCardsView from '../pages/contract-amendment/views/cards.json';
import contractAmendmentCalendarView from '../pages/contract-amendment/views/calendar.json';
import contractAmendmentDashboardView from '../pages/contract-amendment/views/dashboard.json';

/** Тип запису «Зміна до договору» зі сторінками пакета: меню, форми та подання з pages/contract-amendment/. */
export const contractAmendmentDefinition: IRecordTypeDefinition = {
  ...contractAmendmentEntity,
  views: assembleViewSet({
      table: contractAmendmentTableView,
      cards: contractAmendmentCardsView,
      calendar: contractAmendmentCalendarView,
      dashboard: contractAmendmentDashboardView,
  }),
  form: contractAmendmentFullForm,
  forms: { full: contractAmendmentFullForm, context: contractAmendmentContextForm, mini: contractAmendmentMiniForm, lookup: contractAmendmentLookupForm },
  menu: contractAmendmentMenu,
} as IRecordTypeDefinition;
